import { UserOutlined } from '@ant-design/icons';
import { useCurrentUser, useLogoutMenuItem } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import { useHistory } from '@framework/ui';
import type { ItemType } from 'antd/es/menu/interface';
import { useMemo } from 'react';
import { queryClient } from '../../core/network/queryClient';
import { ThemeLogic } from '../theme/ThemeLogic';

/**
 * Ritorna gli elementi del menu utente
 */
export function useUserMenuItems(): { items: ItemType[] } {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const history = useHistory();

  const logoutMenuItem = useLogoutMenuItem({
    onLogout: () => queryClient.clear(),
  });

  const profileMenuItem = useMemo<ItemType>(
    () => ({
      key: 'profile-item-menu',
      icon: <UserOutlined />,
      label: t('frontoffice.menu.profile.label', 'Profilo'),
      title: t('frontoffice.menu.profile.title', 'Accedi al Profilo'),
      onClick: () => {
        history.push('/utente/profilo');
      },
    }),
    [t, history],
  );

  const menu = useMemo(() => {
    const result = [];
    if (ThemeLogic.allowExtendedUserLoginRoutes()) {
      result.push(profileMenuItem);
    }
    result.push(logoutMenuItem);
    return { items: result };
  }, [logoutMenuItem, profileMenuItem]);

  return currentUser ? menu : { items: [] };
}
